// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-BlankLink-BlankLink-module__link--YUUtI.src-components-BlankLink-BlankLink-module__underline--t30Aq {
  text-decoration: underline;
}
.src-components-BlankLink-BlankLink-module__link--YUUtI.src-components-BlankLink-BlankLink-module__primary-orange--Jr6gx {
  color: #fc4807;
}
.src-components-BlankLink-BlankLink-module__link--YUUtI.src-components-BlankLink-BlankLink-module__text-main--t7KPl {
  color: #343a41;
}
/*# sourceMappingURL=BlankLink.module.css.map */`, "",{"version":3,"sources":["webpack://./BlankLink.module.less","webpack://./src/components/BlankLink/BlankLink.module.less"],"names":[],"mappings":"AAGE;EACE,0BAAA;ACFJ;ADKE;EACE,cAAA;ACHJ;ADME;EACE,cAAA;ACJJ;AACA,+CAA+C","sourcesContent":["@import \"../../variables.less\";\n\n.link {\n  &.underline {\n    text-decoration: underline;\n  }\n\n  &.primary-orange {\n    color: @primary-orange;\n  }\n\n  &.text-main {\n    color: @text-main;\n  }\n}\n",".link.underline {\n  text-decoration: underline;\n}\n.link.primary-orange {\n  color: #fc4807;\n}\n.link.text-main {\n  color: #343a41;\n}\n/*# sourceMappingURL=BlankLink.module.css.map */"],"sourceRoot":""}]);
// Exports
export var link = `src-components-BlankLink-BlankLink-module__link--YUUtI`;
export var underline = `src-components-BlankLink-BlankLink-module__underline--t30Aq`;
var _1 = `src-components-BlankLink-BlankLink-module__primary-orange--Jr6gx`;
export { _1 as "primary-orange" };
var _2 = `src-components-BlankLink-BlankLink-module__text-main--t7KPl`;
export { _2 as "text-main" };
export default ___CSS_LOADER_EXPORT___;
